import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../js/coreRuntime.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  joinToString1cxrrlmo0chqs as joinToString,
  asSequence2phdjljfh9jhx as asSequence,
} from '../collections/_Collections.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../collections/Sets.mjs';
import { reset2ep3wdzn2qbpo as reset } from '../js/regexp.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../js/charSequenceJs.mjs';
import {
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../exceptions.mjs';
import { generateSequence2pi96ci7lpz88 as generateSequence } from '../sequences/Sequences.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Char__minus_impl_a2frrh3548ixwefqxih as Char__minus_impl_a2frrh,
} from '../Char.mjs';
import {
  contains2el4s70rdq4ld as contains,
  requireNonNegativeLimit1p78ioqihis7w as requireNonNegativeLimit,
  get_lastIndexld83bqhfgcdd as get_lastIndex,
} from './Strings.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from './StringBuilderJs.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import {
  take2rh6pen3z50h7 as take,
  mapsbvh18eqox7a as map,
} from '../sequences/_Sequences.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../collections/ArrayListJs.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../Enum.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../js/rangeTo.mjs';
import { substringiqarkczpya5m as substring } from './stringJs.mjs';
import { toInt2q8uldh7sc951 as toInt } from './numberConversions.mjs';
import { MatchNamedGroupCollection2nkf1ok7z2wgd as MatchNamedGroupCollection } from './MatchResult.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { AbstractCollection1g9uvtcheckwb as AbstractCollection } from '../collections/AbstractCollection.mjs';
import { get_indices3txodfl5wuu5j as get_indices } from '../collections/CollectionsKt.mjs';
import { AbstractList3ck35puwbp1e9 as AbstractList } from '../collections/AbstractList.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.fh_1 = new RegExp('[\\\\^$*+?.()|[\\]{}]', 'g');
        this.gh_1 = new RegExp('[\\\\$]', 'g');
        this.hh_1 = new RegExp('\\$', 'g');
      }
      ih(literal) {
        // Inline function 'kotlin.text.nativeReplace' call
        var pattern = this.fh_1;
        // Inline function 'kotlin.js.asDynamic' call
        return literal.replace(pattern, '\\$&');
      }
      jh(literal) {
        // Inline function 'kotlin.text.nativeReplace' call
        var pattern = this.hh_1;
        // Inline function 'kotlin.js.asDynamic' call
        return literal.replace(pattern, '$$$$');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function Regex$findAll$lambda(match) {
  return match.o1();
}
var RegexClass;
function Regex() {
  if (RegexClass === VOID) {
    class $ {
      static ph(pattern, options) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.kh_1 = pattern;
        $this.lh_1 = toSet(options);
        $this.mh_1 = new RegExp(pattern, toFlags(options, 'gu'));
        $this.nh_1 = null;
        $this.oh_1 = null;
        return $this;
      }
      static qh(pattern) {
        Companion_getInstance();
        return this.ph(pattern, emptySet());
      }
      rh(input) {
        reset(this.mh_1);
        var match = this.mh_1.exec(toString(input));
        return !(match == null) && match.index === 0 && this.mh_1.lastIndex === charSequenceLength(input);
      }
      sh(input, startIndex) {
        if (startIndex < 0 || startIndex > charSequenceLength(input)) {
          throw IndexOutOfBoundsException().je('Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
        }
        return findNext(this.mh_1, toString(input), startIndex, this.mh_1);
      }
      th(input, startIndex, $super) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        return $super === VOID ? this.sh(input, startIndex) : $super.sh.call(this, input, startIndex);
      }
      uh(input, startIndex) {
        if (startIndex < 0 || startIndex > charSequenceLength(input)) {
          throw IndexOutOfBoundsException().je('Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
        }
        var tmp = () => this.sh(input, startIndex);
        return generateSequence(tmp, Regex$findAll$lambda);
      }
      vh(input, startIndex, $super) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        return $super === VOID ? this.uh(input, startIndex) : $super.uh.call(this, input, startIndex);
      }
      wh(input, replacement) {
        if (!contains(replacement, _Char___init__impl__6a9atx(92)) && !contains(replacement, _Char___init__impl__6a9atx(36))) {
          var tmp0 = toString(input);
          // Inline function 'kotlin.text.nativeReplace' call
          var pattern = this.mh_1;
          // Inline function 'kotlin.js.asDynamic' call
          return tmp0.replace(pattern, replacement);
        }
        return this.xh(input, (it) => substituteGroupRefs(it, replacement));
      }
      xh(input, transform) {
        var match = this.th(input);
        if (match == null)
          return toString(input);
        var lastStart = 0;
        var length = charSequenceLength(input);
        var sb = StringBuilder().bc(length);
        do {
          var foundMatch = ensureNotNull(match);
          sb.vg(input, lastStart, foundMatch.yh().j1());
          sb.e1(transform(foundMatch));
          lastStart = foundMatch.yh().k1() + 1 | 0;
          match = foundMatch.o1();
        }
         while (lastStart < length && !(match == null));
        if (lastStart < length) {
          sb.vg(input, lastStart, length);
        }
        return sb.toString();
      }
      zh(input, limit) {
        requireNonNegativeLimit(limit);
        // Inline function 'kotlin.let' call
        var it = this.vh(input);
        var matches = limit === 0 ? it : take(it, limit - 1 | 0);
        // Inline function 'kotlin.collections.mutableListOf' call
        var result = ArrayList().w();
        var lastStart = 0;
        var _iterator__ex2g4s = matches.m1();
        while (_iterator__ex2g4s.n1()) {
          var match = _iterator__ex2g4s.o1();
          result.v(toString(charSequenceSubSequence(input, lastStart, match.yh().j1())));
          lastStart = match.yh().k1() + 1 | 0;
        }
        result.v(toString(charSequenceSubSequence(input, lastStart, charSequenceLength(input))));
        return result;
      }
      toString() {
        return this.mh_1.toString();
      }
    }
    initMetadataForClass($, 'Regex');
    RegexClass = $;
  }
  return RegexClass;
}
var RegexOption_IGNORE_CASE_instance;
var RegexOption_MULTILINE_instance;
var RegexOption_entriesInitialized;
function RegexOption_initEntries() {
  if (RegexOption_entriesInitialized)
    return Unit_instance;
  RegexOption_entriesInitialized = true;
  RegexOption_IGNORE_CASE_instance = RegexOption().di('IGNORE_CASE', 0, 'i');
  RegexOption_MULTILINE_instance = RegexOption().di('MULTILINE', 1, 'm');
}
var RegexOptionClass;
function RegexOption() {
  if (RegexOptionClass === VOID) {
    class $ extends Enum() {
      static di(name, ordinal, value) {
        var $this = this.c4(name, ordinal);
        $this.ci_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'RegexOption');
    RegexOptionClass = $;
  }
  return RegexOptionClass;
}
function toFlags(_this__u8e3s4, prepend) {
  return joinToString(_this__u8e3s4, '', prepend, VOID, VOID, VOID, toFlags$lambda);
}
function findNext(_this__u8e3s4, input, from, nextPattern) {
  _this__u8e3s4.lastIndex = from;
  var match = _this__u8e3s4.exec(input);
  if (match == null)
    return null;
  var range = numberRangeToNumber(match.index, _this__u8e3s4.lastIndex - 1 | 0);
  return new (findNext$1())(range, match, nextPattern, input);
}
function substituteGroupRefs(match, replacement) {
  var index = 0;
  var result = StringBuilder().d1();
  while (index < replacement.length) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var char = charCodeAt(replacement, _unary__edvuaz);
    if (char === _Char___init__impl__6a9atx(92)) {
      if (index === replacement.length)
        throw IllegalArgumentException().a1('The Char to be escaped is missing');
      var _unary__edvuaz_0 = index;
      index = _unary__edvuaz_0 + 1 | 0;
      result.xb(charCodeAt(replacement, _unary__edvuaz_0));
    } else if (char === _Char___init__impl__6a9atx(36)) {
      if (index === replacement.length)
        throw IllegalArgumentException().a1('Capturing group index is missing');
      if (charCodeAt(replacement, index) === _Char___init__impl__6a9atx(123)) {
        index = index + 1 | 0;
        var endIndex = readGroupName(replacement, index);
        if (index === endIndex)
          throw IllegalArgumentException().a1('Named capturing group reference should have a non-empty name');
        if (endIndex === replacement.length || !(charCodeAt(replacement, endIndex) === _Char___init__impl__6a9atx(125)))
          throw IllegalArgumentException().a1("Named capturing group reference is missing trailing '}'");
        var groupName = substring(replacement, index, endIndex);
        var tmp0_safe_receiver = get(match.ei(), groupName);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fi_1;
        result.wb(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
        index = endIndex + 1 | 0;
      } else {
        var containsArg = charCodeAt(replacement, index);
        if (!(_Char___init__impl__6a9atx(48) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57) : false))
          throw IllegalArgumentException().a1('Invalid capturing group reference');
        var groups = match.ei();
        var endIndex_0 = readGroupIndex(replacement, index, groups.p1());
        var groupIndex = toInt(substring(replacement, index, endIndex_0));
        if (groupIndex >= groups.p1())
          throw IndexOutOfBoundsException().je('Group with index ' + groupIndex + ' does not exist');
        var tmp2_safe_receiver = groups.q1(groupIndex);
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.fi_1;
        result.wb(tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs);
        index = endIndex_0;
      }
    } else {
      result.xb(char);
    }
  }
  return result.toString();
}
var MatchGroupClass;
function MatchGroup() {
  if (MatchGroupClass === VOID) {
    class $ {
      constructor(value) {
        this.fi_1 = value;
      }
      toString() {
        return 'MatchGroup(value=' + this.fi_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.fi_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MatchGroup()))
          return false;
        if (!(this.fi_1 === other.fi_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MatchGroup');
    MatchGroupClass = $;
  }
  return MatchGroupClass;
}
function readGroupName(_this__u8e3s4, startIndex) {
  var index = startIndex;
  $l$loop: while (index < _this__u8e3s4.length) {
    if (charCodeAt(_this__u8e3s4, index) === _Char___init__impl__6a9atx(125)) {
      break $l$loop;
    } else {
      index = index + 1 | 0;
    }
  }
  return index;
}
function get(_this__u8e3s4, name) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, MatchNamedGroupCollection()) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw UnsupportedOperationException().i5('Retrieving groups by name is not supported on this platform.');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var namedGroups = tmp;
  return namedGroups.gi(name);
}
function readGroupIndex(_this__u8e3s4, startIndex, groupCount) {
  var index = startIndex + 1 | 0;
  var groupIndex = Char__minus_impl_a2frrh(charCodeAt(_this__u8e3s4, startIndex), _Char___init__impl__6a9atx(48));
  $l$loop_0: while (true) {
    var tmp;
    if (index < _this__u8e3s4.length) {
      var containsArg = charCodeAt(_this__u8e3s4, index);
      tmp = _Char___init__impl__6a9atx(48) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57) : false;
    } else {
      tmp = false;
    }
    if (!tmp) {
      break $l$loop_0;
    }
    var newGroupIndex = imul(groupIndex, 10) + Char__minus_impl_a2frrh(charCodeAt(_this__u8e3s4, index), _Char___init__impl__6a9atx(48)) | 0;
    if (0 <= newGroupIndex ? newGroupIndex < groupCount : false) {
      groupIndex = newGroupIndex;
      index = index + 1 | 0;
    } else {
      break $l$loop_0;
    }
  }
  return index;
}
function toFlags$lambda(it) {
  return it.ci_1;
}
function hasOwnPrototypeProperty($this, o, name) {
  // Inline function 'kotlin.js.unsafeCast' call
  return Object.prototype.hasOwnProperty.call(o, name);
}
function advanceToNextCharacter($this, index) {
  if (index < get_lastIndex($this.ni_1)) {
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var code1 = $this.ni_1.charCodeAt(index);
    if (55296 <= code1 ? code1 <= 56319 : false) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var code2 = $this.ni_1.charCodeAt(index + 1 | 0);
      if (56320 <= code2 ? code2 <= 57343 : false) {
        return index + 2 | 0;
      }
    }
  }
  return index + 1 | 0;
}
var findNext$1$groups$1Class;
function findNext$1$groups$1() {
  if (findNext$1$groups$1Class === VOID) {
    class $ extends AbstractCollection() {
      static qi($match, this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.oi_1 = $match;
        $box.pi_1 = this$0;
        return this.j6($box);
      }
      p1() {
        return this.oi_1.length;
      }
      m1() {
        var tmp = asSequence(get_indices(this));
        return map(tmp, (it) => this.q1(it)).m1();
      }
      q1(index) {
        // Inline function 'kotlin.js.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = this.oi_1[index];
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = new (MatchGroup())(tmp0_safe_receiver);
        }
        return tmp;
      }
      gi(name) {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_elvis_lhs = this.oi_1.groups;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalArgumentException().a1('Capturing group with name {' + name + '} does not exist. No named capturing group was defined in Regex');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var groups = tmp;
        if (!hasOwnPrototypeProperty(this.pi_1, groups, name))
          throw IllegalArgumentException().a1('Capturing group with name {' + name + '} does not exist');
        var value = groups[name];
        var tmp_0;
        if (value == undefined) {
          tmp_0 = null;
        } else {
          tmp_0 = new (MatchGroup())((!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [MatchNamedGroupCollection(), AbstractCollection()]);
    findNext$1$groups$1Class = $;
  }
  return findNext$1$groups$1Class;
}
var findNext$1$groupValues$1Class;
function findNext$1$groupValues$1() {
  if (findNext$1$groupValues$1Class === VOID) {
    class $ extends AbstractList() {
      static si($match, $box) {
        if ($box === VOID)
          $box = {};
        $box.ri_1 = $match;
        return this.ti($box);
      }
      p1() {
        return this.ri_1.length;
      }
      q1(index) {
        // Inline function 'kotlin.js.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_elvis_lhs = this.ri_1[index];
        return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
      }
    }
    initMetadataForClass($);
    findNext$1$groupValues$1Class = $;
  }
  return findNext$1$groupValues$1Class;
}
var findNext$1Class;
function findNext$1() {
  if (findNext$1Class === VOID) {
    class $ {
      constructor($range, $match, $nextPattern, $input) {
        this.ki_1 = $range;
        this.li_1 = $match;
        this.mi_1 = $nextPattern;
        this.ni_1 = $input;
        this.hi_1 = $range;
        var tmp = this;
        tmp.ii_1 = findNext$1$groups$1().qi($match, this);
        this.ji_1 = null;
      }
      yh() {
        return this.hi_1;
      }
      f2() {
        // Inline function 'kotlin.js.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = this.li_1[0];
        return ensureNotNull(tmp$ret$1);
      }
      ei() {
        return this.ii_1;
      }
      ui() {
        if (this.ji_1 == null) {
          var tmp = this;
          tmp.ji_1 = findNext$1$groupValues$1().si(this.li_1);
        }
        return ensureNotNull(this.ji_1);
      }
      o1() {
        return findNext(this.mi_1, this.ni_1, this.ki_1.i1() ? advanceToNextCharacter(this, this.ki_1.j1()) : this.ki_1.k1() + 1 | 0, this.mi_1);
      }
    }
    initMetadataForClass($);
    findNext$1Class = $;
  }
  return findNext$1Class;
}
function RegexOption_IGNORE_CASE_getInstance() {
  RegexOption_initEntries();
  return RegexOption_IGNORE_CASE_instance;
}
//region block: exports
export {
  RegexOption_IGNORE_CASE_getInstance as RegexOption_IGNORE_CASE_getInstance1e6t23ud6ux7i,
  Companion_getInstance as Companion_getInstanceduyatss8wab7,
  Regex as Regexxgw0gjiagf4z,
};
//endregion

//# sourceMappingURL=regex.mjs.map
